import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ConfigService } from './shared/services/config/config.service';
import { Constants } from './shared/constants';
import { TranslationsService } from './shared/services/translations/translations.service';
import { SharedDataService } from './shared/services/shared-data/shared-data.service';
import { TranslatePipe } from './shared/pipes/translate.pipe';
import { HttpClient } from '@angular/common/http';
import { AnalyticsService, ConfigService as AnalyticsConfigService } from '@wdpr/angular-analytics';

import '@wdpr/input';
import '@wdpr/button';
import '@wdpr/image';
import '@wdpr/checkbox';
import '@wdpr/loading';
import '@wdpr/mdx-icons';
import '@wdpr/messages';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [TranslatePipe]
})
export class AppComponent implements OnInit {
  /**
   * Syndicated header configuration
   * @var {any}
   */
  public syndicatedHeaderConfig: any;

  /**
   * Application configuration
   * @var {any}
   */
  private _config: any;

  /**
   * Translations object
   * @var {any}
   */
  private _translations: any;

  /**
   * When true, Profile Authenticator Universal JS is used (APP_INITIALIZER runs AngularInit.runNow).
   * Used by syndicated header binding. See docs/clmspadlr-authenticator-universal-integration-plan.md Step 5 & 6.
   */
  public isUniversalAuthEnabled = false;

  /**
   * Class constructor
   *
   * @param _configService
   * @param _translationsService
   * @param _titleService
   * @param _translatePipe
   * @param _location
   */
  constructor(
    private _configService: ConfigService,
    private _translationsService: TranslationsService,
    private _titleService: Title,
    private _translatePipe: TranslatePipe,
    private _location: Location,
    private _http: HttpClient,
    private _sharedDataService: SharedDataService,
    private analyticsSvc: AnalyticsService,
    private analyticsCfgSvc: AnalyticsConfigService
  ) {
    this._config = this._configService.getConfig();
    this._translations = this._translationsService.getTranslations();
    this.analyticsCfgSvc.loader = pagekey => this._http.get(`assets/analytics/${pagekey}.json`).toPromise();
  }

  /**
   * On init method
   */
  public ngOnInit() {
    this._titleService.setTitle(this._translatePipe.transform('title'));

    // Set isUniversalAuthEnabled from config
    this.isUniversalAuthEnabled = this._config?.isUniversalAuthEnabled === true;

    this._setSyndicatedHeaderConfig();

    document.addEventListener('navigation', (event:any) => {
      if (event.detail.event === 'oneId-init') {
        // update intialized value for auth guard to handle token
        this._sharedDataService.updateValue(
          'profileAuthInitialized',
          true
        );
      } else if (event.detail.event === 'navigationAuthListening') {
        // Prevent login reload
        document.dispatchEvent(
          new CustomEvent('navigationAuth', {
            detail: {
              method: 'launchLogin',
              preventExecuteOneIdMethod: true,
              preventReloadAndRedirect: true,
            },
          })
        );
      }
    });
  }

  /**
   * Sets the syndicated header configuration
   *
   * @returns {void}
   */
  private _setSyndicatedHeaderConfig(): void {
    const config = this._config as any;
    if (!config?.syndicatedConfig?.header) {
      return;
    }
    this.syndicatedHeaderConfig = {
      path: `${config.syndicatedConfig.baseUrl}${config.syndicatedConfig.header.path}`,
      version: config.syndicatedConfig.header.version,
      siteId: config.syndicatedConfig.siteId,
      environment: config.environment
    };
  }
}
